import { z } from "zod";
import { apiRequest } from "../../../../shared/api/client";
import type { Rfq } from "../../domain/rfq-types";
import type { rfqDraftPayload } from "../../domain/rfq-draft";

const selectionSchema = z.object({
  supplier_id: z.string().optional(), supplierId: z.string().optional(),
  supplier_name: z.string().optional(), supplierName: z.string().optional(),
  blocking_reasons: z.array(z.string()).optional(), blockingReasons: z.array(z.string()).optional(),
}).passthrough();
const rfqSchema = z.object({
  id: z.string().min(1), status: z.string().min(1), method: z.string().min(1),
  timezone: z.string().min(1), confidentiality: z.string().min(1),
  rfq_no: z.string().optional(), rfqNo: z.string().optional(),
  current_version: z.number().optional(), currentVersion: z.number().optional(),
  deadline_at: z.string().optional(), deadlineAt: z.string().optional(),
  selections: z.array(selectionSchema).optional(),
  events: z.array(z.object({ event_type: z.string().optional(), eventType: z.string().optional(), occurred_at: z.string().optional(), at: z.string().optional() }).passthrough()).optional(),
}).passthrough();
const candidatesSchema = z.array(z.object({ id: z.string().min(1), name: z.string(), eligible: z.boolean(), blockingReasons: z.array(z.string()) }).passthrough());
const invalidResponse = () => Object.assign(new Error("Teklif talebinin sunucu yanıtı doğrulanamadı."), { code: "INVALID_API_RESPONSE" });
function parseRfq(value: unknown, expectedId?: string): Rfq {
  const parsed = rfqSchema.safeParse(value);
  if (!parsed.success || expectedId && parsed.data.id !== expectedId) throw invalidResponse();
  return parsed.data;
}
export async function createRfqDraft(payload: ReturnType<typeof rfqDraftPayload>) {
  return parseRfq(await apiRequest<unknown>("/api/rfqs", { method: "POST", headers: { "Idempotency-Key": crypto.randomUUID() }, body: JSON.stringify(payload) }));
}
export async function readRfqDraftCandidates(rfqId: string) {
  const parsed = candidatesSchema.safeParse(await apiRequest<unknown>(`/api/rfqs/${rfqId}/candidates`));
  if (!parsed.success) throw invalidResponse();
  return parsed.data;
}
export async function saveRfqSelection(rfq: Rfq, supplierIds: string[]) {
  return parseRfq(await apiRequest<unknown>(`/api/rfqs/${rfq.id}/selections`, {
    method: "POST", headers: { "Idempotency-Key": crypto.randomUUID() },
    body: JSON.stringify({ supplierIds, expectedVersion: rfq.current_version ?? rfq.currentVersion }),
  }), rfq.id);
}
export type RfqLifecycleAction = "method-decision" | "publish" | "await-bids" | "close" | "cancel";
export async function changeRfqLifecycle(rfq: Rfq, action: RfqLifecycleAction, reason: string) {
  return parseRfq(await apiRequest<unknown>(`/api/rfqs/${rfq.id}/${action}`, {
    method: "POST", headers: { "Idempotency-Key": crypto.randomUUID() },
    body: JSON.stringify({ expectedVersion: rfq.current_version ?? rfq.currentVersion, reason }),
  }), rfq.id);
}
